import { useTranslation } from "react-i18next";

export const useEstadoPago = () => {
    const { t } = useTranslation();
    const ESTADO_PAGO = [
        { value: 1, label: t("estado_pago_pagado") },
        { value: 2, label: t("estado_pago_mora") },
    ];
    return ESTADO_PAGO;
};
